<template>
  <el-dialog
    :title="isUpdate ? '编辑虚拟币' : '添加虚拟币'"
    :visible="visible"
    width="600px"
    :destroy-on-close="true"
    :lock-scroll="false"
    custom-class="ele-dialog-form"
    append-to-body
    @update:visible="updateVisible">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="币种代码:" prop="code">
        <el-input v-model="form.code" clearable placeholder="请输入" maxlength="20" />
      </el-form-item>
      <el-form-item label="币种名称:" prop="name">
        <el-input v-model="form.name" clearable placeholder="请输入" maxlength="100" />
      </el-form-item>
      <el-form-item label="所属链:" prop="chain">
        <el-select v-model="form.chain" clearable filterable class="ele-fluid" placeholder="请选择">
          <el-option v-for="item in chainOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-row :gutter="15">
        <el-col :sm="12">
          <el-form-item label="排序:" prop="sort">
            <el-input-number v-model="form.sort" :min="0" :max="9999" controls-position="right" class="ele-fluid" />
          </el-form-item>
        </el-col>
        <el-col :sm="12">
          <el-form-item label="状态:" prop="status">
            <el-radio-group v-model="form.status">
              <el-radio v-for="item in statusOptions" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注:" prop="note">
        <el-input v-model="form.note" type="textarea" :rows="2" resize="none" placeholder="请输入" maxlength="255" show-word-limit />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="updateVisible(false)">取消</el-button>
      <el-button type="primary" :loading="loading" @click="save">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getDictData, loadDictOptions } from '@/utils/dict';

const defaultForm = () => ({ code: '', name: '', chain: '', status: 1, sort: 0, note: '' });

export default {
  name: 'VirtualCurrencyEdit',
  props: {
    visible: Boolean,
    data: Object
  },
  data() {
    return {
      form: defaultForm(),
      rules: {
        code: [{ required: true, message: '请输入', trigger: 'blur' }],
        name: [{ required: true, message: '请输入', trigger: 'blur' }],
        chain: [{ required: true, message: '请选择', trigger: 'change' }],
        status: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      loading: false,
      isUpdate: false,
      chainOptions: [],
      statusOptions: []
    };
  },
  created() {
    this.loadChainOptions();
    loadDictOptions('switch_status', { numberValue: true })
      .then((list) => { this.statusOptions = list; })
      .catch((e) => { this.$message.error(e.message); });
  },
  watch: {
    visible(val) {
      if (val) {
        this.initForm();
        if (!this.chainOptions.length) {
          this.loadChainOptions();
        }
      }
    },
    data() {
      if (this.visible) {
        this.initForm();
      }
    }
  },
  methods: {
    loadChainOptions() {
      getDictData('chain_list')
        .then((list) => {
          this.chainOptions = (list || []).map((item) => ({
            value: item.dictDataCode,
            label: item.dictDataName
          }));
        })
        .catch((e) => {
          this.$message.error(e.message);
        });
    },
    initForm() {
      if (this.data && Object.keys(this.data).length) {
        this.form = Object.assign(defaultForm(), this.data);
        this.isUpdate = true;
      } else {
        this.form = defaultForm();
        this.isUpdate = false;
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      });
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.loading = true;
        this.$http.post('/VirtualCurrency/edit', this.form).then((res) => {
          this.loading = false;
          if (res.data.code === 0) {
            this.$message.success(res.data.msg || '保存成功');
            this.updateVisible(false);
            this.$emit('done');
          } else {
            this.$message.error(res.data.msg || '保存失败');
          }
        }).catch((e) => {
          this.loading = false;
          this.$message.error(e.message);
        });
      });
    },
    updateVisible(value) {
      this.$emit('update:visible', value);
    }
  }
};
</script>
